import { render, staticRenderFns } from "./user-header.vue?vue&type=template&id=27bd152e&"
import script from "./user-header.vue?vue&type=script&lang=js&"
export * from "./user-header.vue?vue&type=script&lang=js&"
import style0 from "./user-header.vue?vue&type=style&index=0&id=27bd152e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports